import { useTranslation } from 'react-i18next';
import { SearchIcon } from './svg/Search';
import { FC } from 'react';
import classNames from 'classnames';
import { useModalContext } from 'src/hooks/useModalContext';
import { useDrawer } from 'src/hooks/useDrawer';

interface SearchProps {
  compact?: boolean;
}

export const Search: FC<SearchProps> = ({ compact = false }) => {
  const { closeDrawer } = useDrawer();
  const { openModal } = useModalContext();
  const { t } = useTranslation();

  const handleOpenSearchModal = () => {
    if (!compact) closeDrawer();
    openModal('SEARCH');
  };

  return (
    <div
      className={classNames(
        compact
          ? 'w-10 h-10'
          : 'w-full h-12 py-2.5 px-5 gap-2.5 rounded-lg bg-sh_bg border border-solid border-sh_border',
        'flex justify-center items-center cursor-pointer'
      )}
      onClick={handleOpenSearchModal}>
      <SearchIcon className="w-5 h-5" />
      {!compact && <p className="text-left text-sh_text flex-1">{t('general.search')}</p>}
    </div>
  );
};
